import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { DatabaseBackup, KeyRound, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, PageHeader, btnPrimary, inputCls } from "@/components/app/common";
import { DatiAzienda } from "@/components/app/DatiAzienda";

export default function Profilo() {
  const { user, isAdmin } = useAuth();
  const [f, setF] = useState({ vecchia: "", nuova: "", conferma: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    if (f.nuova.length < 6) return toast.error("La nuova password deve avere almeno 6 caratteri");
    if (f.nuova !== f.conferma) return toast.error("Le due nuove password non coincidono");
    setSaving(true);
    try {
      await api.post("/auth/password", { vecchia_password: f.vecchia, nuova_password: f.nuova });
      toast.success("Password aggiornata con successo");
      setF({ vecchia: "", nuova: "", conferma: "" });
    } catch (err) { toast.error(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="profilo-page">
      <PageHeader overline="Account" title="Il mio profilo" />
      <div className="grid lg:grid-cols-2 gap-5 max-w-4xl">
        <section className="card-soft p-6" data-testid="profilo-info">
          <h2 className="text-lg font-medium mb-4">I tuoi dati</h2>
          <dl className="space-y-3 text-sm">
            <div><dt className="text-xs text-[#756B64]">Nome</dt><dd className="font-medium" data-testid="profilo-nome">{user.name}</dd></div>
            <div><dt className="text-xs text-[#756B64]">Email</dt><dd className="font-medium" data-testid="profilo-email">{user.email}</dd></div>
            <div><dt className="text-xs text-[#756B64]">Ruolo</dt><dd className="font-medium">{isAdmin ? "Amministratore" : "Collaboratore"}</dd></div>
          </dl>
        </section>
        <form onSubmit={save} className="card-soft p-6 space-y-4" data-testid="password-form">
          <h2 className="text-lg font-medium flex items-center gap-2"><KeyRound className="h-4 w-4 text-[#8C6D62]" />Cambia password</h2>
          <Field label="Password attuale"><Input type="password" required data-testid="password-old-input" value={f.vecchia} onChange={set("vecchia")} className={inputCls} /></Field>
          <Field label="Nuova password" hint="Almeno 6 caratteri."><Input type="password" required data-testid="password-new-input" value={f.nuova} onChange={set("nuova")} className={inputCls} /></Field>
          <Field label="Ripeti nuova password"><Input type="password" required data-testid="password-confirm-input" value={f.conferma} onChange={set("conferma")} className={inputCls} /></Field>
          <Button type="submit" className={btnPrimary} disabled={saving} data-testid="password-save-button">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aggiorna password"}</Button>
        </form>
        {isAdmin && <DatiAzienda />}
        {isAdmin && (
          <section className="card-soft p-6 lg:col-span-2 flex flex-wrap items-center justify-between gap-3" data-testid="profilo-backup-card">
            <div>
              <h2 className="text-lg font-medium flex items-center gap-2"><DatabaseBackup className="h-4 w-4 text-[#8C6D62]" />Backup e ripristino</h2>
              <p className="text-xs text-[#756B64] mt-1">Scarica tutti i dati in un file o trasferiscili su un'altra installazione.</p>
            </div>
            <Link to="/backup" data-testid="profilo-backup-link" className="rounded-full border border-[#EAE3DC] px-4 py-2 text-sm font-medium hover:bg-[#F4EFEA]">Apri</Link>
          </section>
        )}
      </div>
    </div>
  );
}
